import { Pill, RetryRotatedIcon } from '@ui/kit';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { retryButton } from './atom.retry-button.style.js';
import { jsx } from 'react/jsx-runtime';

function RetryButton(props) {
  const update = useUpdateInputMutation();
  const onReset = () => {
    const input = props.inputRef.current;
    update(props.taskEntryKey, props.input.id, prev => ({
      type: "text-correction",
      validationType: "with-start-comma",
      ...prev,
      text: props.input.initialText
    }));
    if (input) {
      input.innerText = props.input.initialText;
    }
  };
  return /*#__PURE__*/jsx(Pill, {
    className: retryButton,
    icon: /*#__PURE__*/jsx(RetryRotatedIcon, {}),
    theme: "transparent",
    onClick: onReset,
    children: "Nulstil til original tekst"
  });
}

export { RetryButton };
//# sourceMappingURL=atom.retry-button.js.map
